import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { ClienteSelectRedux } from '../../providers/redux/clienteselect/clienteselect';
import { UtilsRedux } from '../../providers/redux/utils/utils'
import { Clienteselect } from '../../models/clienteselect/clienteselect.models';
import { Storage } from '@ionic/storage'
/**
 * Generated class for the ClienteSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cliente-select',
  templateUrl: 'cliente-select.html',
  providers: [ClienteSelectRedux, UtilsRedux]
})
export class ClienteSelectPage {
  data:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  item: string = '';
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public viewControllers:ViewController,
              public clienteSelectRedux: ClienteSelectRedux,
              public utilsRedux: UtilsRedux,
              public storage: Storage) {
    if(this.navParams.get('data')){
      this.data = this.navParams.get('data')
    } else {
      this.buscarValoresSelectStore();
    }
  }

  async buscarValoresSelectStore() {
    let estados: any = await this.utilsRedux.buscarEstadosStore();
    let existeUsuario = estados !== null && estados.usuarioSelect === true ? estados.usuarioSelect : false

      if(!existeUsuario) {
        let clienteSelect: any = await this.clienteSelectRedux.buscarClienteSelectStore();
        this.data = clienteSelect !== undefined && clienteSelect.clienteselect !== undefined &&  clienteSelect.clienteselect.length > 0 ? clienteSelect.clienteselect : []
        if(this.data.length>0) {
          let values: any = this.data.map((items: any) => {
            return {value:items.clientesId,display:items.nombreCliente}
          })
          this.data = values
        }
      } else {
        let usuarioSelect: any = await this.utilsRedux.buscarUsuarioSelectStore();
        this.data =usuarioSelect !== undefined && usuarioSelect.valuedisplay.length > 0  ? usuarioSelect.valuedisplay : []
        if(this.data.length>0) {
        let values: any = this.data.map((items: any) => {
            return {value:items.usuariosId,display:items.nombreUsuario}
          })
          this.data = values
        }
      }

  }

  ionViewDidLoad() {
    this.paginaActual = 1;
  }

  dismiss(){
    this.viewControllers.dismiss();
  }

  submit(){
   this.viewControllers.dismiss(this.item);
  }

  buscar(event) {
    this.buscarTexto = event.value;
  }
  devolverValor(item) {
    this.item = item;
    this.submit();
  }
}



// WEBPACK FOOTER //
// ./src/pages/cliente-select/cliente-select.ts